<template>
  <van-pull-refresh v-model="pullLoading" @refresh="onRefresh">
    <div class="publicService">
      <section class="publicServiceMoney">
        <div class="money">已筹备(元）
          <div class="number" style="font-size: 24px; margin-top: -1px;">{{preparation}}</div>
        </div>
        <div class="money">已捐出(元）
          <div class="number" style="font-size: 18px">2,170,000</div>
        </div>
      </section>
      <section class="publicServiceNotes">
        <div class="publicServiceTitle">公益大事记</div>
        <div class="notesContainer">
          <swiper :options="swiperOption">
            <swiper-slide v-for="(item, index) in notesList" :key="index">
              <img :src="item.image" alt="" />
            </swiper-slide>
          </swiper>
          <div class="swiperPagination">
            <div class="paginationContainer" :style="{transform: 'translate(' + moveNumber + 'px, 0)'}">
              <div class="paginationDots" :style="{width: (notesList.length + 4) * paginationWidth + 'px'}">
                <div class="dots" :style="{width: paginationWidth + 'px'}"><span></span></div>
                <div class="dots" :style="{width: paginationWidth + 'px'}"><span></span></div>
                <div class="dots" v-for="(item, index) in notesList" :key="index" :style="{width: paginationWidth + 'px'}"><span :class="{dotsActive: sellerIndex == index}"></span></div>
                <div class="dots" :style="{width: paginationWidth + 'px'}"><span></span></div>
                <div class="dots" :style="{width: paginationWidth + 'px'}"><span></span></div>
              </div>
              <div class="paginationDate" :style="{width: (notesList.length + 4) * paginationWidth + 'px'}">
                <div class="date" :style="{width: paginationWidth + 'px'}"></div>
                <div class="date" :style="{width: paginationWidth + 'px'}"></div>
                <div class="date" v-for="(item, index) in notesList" :key="index" :class="{dateActive: sellerIndex == index}" :style="{width: paginationWidth + 'px', color: sellerIndex > 0 && sellerIndex - 1 == index || sellerIndex < notesList.length - 1 && sellerIndex + 1 == index? '#8F8F8F' : ''}">{{item.date}}</div>
                <div class="date" :style="{width: paginationWidth + 'px'}"></div>
                <div class="date" :style="{width: paginationWidth + 'px'}"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="publicServiceProcedure">
        <div class="publicServiceTitle">捐助流程
          <img src="https://res.ponhu.cn/publicServiceNotes/publicServiceHow.png" alt="" @click="popupVisible = true" />
        </div>
        <img src="https://res.ponhu.cn/publicServiceNotes/publicServiceProcedur.png" alt="" />
      </section>
      <section class="publicServiceGoods" v-if="goodsList && goodsList.length > 0">
        <div class="publicServiceTitle">义卖商品</div>
        <div class="goodsTip">以下商品成交后，胖虎会以买家名义将对应收入全部捐出</div>
        <ul>
          <li v-for="(item, index) in goodsList" :key="index" @click="goDetail(item.goodsid)">
            <img src="https://res.ponhu.cn/publicServiceNotes/publicServiceLabel.png" alt="">
            <div class="goodsImage">
              <img :src="item.goods_images" alt="" />
              <img src="https://res.ponhu.cn/publicServiceNotes/publicServiceSole.png" alt="" class="label" v-if="item.isSlod == 1"/>
            </div>
            <div class="goodsNews">
              <div class="brand" ><span>{{item.english}}</span><div class="status" v-if="item.colourName">{{item.colourName}}</div></div>
              <div class="describe">“ 平台方一番心意，希望帮助到有需要的人 ”</div>
              <div class="price">￥{{item.ph_price}}
                <span v-if="item.original_price && item.original_price > 0">¥{{item.original_price}}</span>
              </div>
              <div class="people">
                <img src="https://res.ponhu.cn/publicServiceNotes/publicServicePeople.png" alt="" />
                <span>胖虎官方</span>
              </div>
            </div>
          </li>
        </ul>
      </section>
      <section class="publicServiceBanner">
        <van-swipe ref="swiper" :autoplay="3000" :show-indicators="false" @change="changeBanner">
          <van-swipe-item v-for="(item, index) in bannerList" :key="index" @click="goNative(item.title, item.url)">
            <img :src="item.image" alt="" />
          </van-swipe-item>
        </van-swipe>
        <div class="bannerContaner" @touchstart="startBanner" @touchmove="moveBanner" @touchend="endBanner" @click="goNative(bannerList[current].title, bannerList[current].url)">
          <div class="bannerNews">
            <div class="title">{{bannerList[current].name}}</div>
            <div class="synopsis">{{bannerList[current].synopsis}}</div>
          </div>
          <div class="indicator">{{current + 1}}<span>/{{bannerList.length}}</span></div>
        </div>
      </section>
      <section class="publicServiceAbout">
        <div class="publicServiceTitle">关于胖虎公益</div>
        <div class="aboutContainer">作为一家二手奢侈品交易平台，胖虎奢侈品想要通过慈善义卖及公益行活动让更多人理解：真正意义上的奢侈品，并不是单纯的攀比或财富的象征，而应该是一种高贵、善良的价值观和生活态度。未来，胖虎的慈善公益活动会一直进行，除了不间断的给困难儿童提供更多的物资支持，也会持续关注流浪小动物等更多弱势群体的需求。胖虎相信，只要我们每个人每个企业都传递出一点点爱，这个世界就能多一些美好。</div>
      </section>
      <van-popup v-model="popupVisible" round position="bottom" :close-on-click-overlay="false">
        <div class="title"><img src="../../assets/img/closePopup.png" alt="" @click="popupVisible = false" />如何捐赠义卖商品</div>
        <div class="popupNews">
          <p>第一步 添加官方客服微信【{{wechatNumber}}】<a class="wechatNumber" data-clipboard-action="copy" :data-clipboard-text="wechatNumber" @click="copy">复制微信</a></p>
          <p>第二步 给客服发送宝贝图片进行线上鉴定</p>
          <p>第三步 将宝贝寄送平台，进行验货评估</p>
          <p>第四步 验货成功后，与客服沟通确认义卖价格</p>
          <p>第五步 价格确认后，宝贝即可参与义卖活动</p>
        </div>
        <div class="complete" @click="popupVisible = false">完成</div>
      </van-popup>
    </div>
  </van-pull-refresh>
</template>

<script>
import ClipboardJS from 'clipboard';
import { BrowserInfo } from '@/utils';
import { getPublicWelfarePager } from '@/api/publicService';

let vm = null;
let notesList = [
  {
    image: 'https://res.ponhu.cn/publicServiceNotes/publicServiceNotesImage17.png',
    date: '2020.2'
  },
  {
    image: 'https://res.ponhu.cn/publicServiceNotes/publicServiceNotesImage16.png',
    date: '2020.1'
  },
  {
    image: 'https://res.ponhu.cn/publicServiceNotes/publicServiceNotesImage15.png',
    date: '2018.12'
  },
  {
    image: 'https://res.ponhu.cn/publicServiceNotes/publicServiceNotesImage14.png',
    date: '2018.11'
  },
  {
    image: 'https://res.ponhu.cn/publicServiceNotes/publicServiceNotesImage12.png',
    date: '2018.9'
  },
  {
    image: 'https://res.ponhu.cn/publicServiceNotes/publicServiceNotesImage11.png',
    date: '2018.5'
  },
  {
    image: 'https://res.ponhu.cn/publicServiceNotes/publicServiceNotesImage9.png',
    date: '2018.4'
  },
  {
    image: 'https://res.ponhu.cn/publicServiceNotes/publicServiceNotesImage10.png',
    date: '2018.5'
  },
  {
    image: 'https://res.ponhu.cn/publicServiceNotes/publicServiceNotesImage13.png',
    date: '2018'
  },
  {
    image: 'https://res.ponhu.cn/publicServiceNotes/publicServiceNotesImage8.png',
    date: '2017.7'
  },
  {
    image: 'https://res.ponhu.cn/publicServiceNotes/publicServiceNotesImage7.png',
    date: '2017.1'
  },
  {
    image: 'https://res.ponhu.cn/publicServiceNotes/publicServiceNotesImage6.png',
    date: '2016.12'
  },
  {
    image: 'https://res.ponhu.cn/publicServiceNotes/publicServiceNotesImage4.png',
    date: '2016.9'
  },
  {
    image: 'https://res.ponhu.cn/publicServiceNotes/publicServiceNotesImage3.png',
    date: '2016.9'
  },
  {
    image: 'https://res.ponhu.cn/publicServiceNotes/publicServiceNotesImage2.png',
    date: '2016.5'
  },
  {
    image: 'https://res.ponhu.cn/publicServiceNotes/publicServiceNotesImage1.png',
    date: '2016'
  }
];
let number = parseInt(notesList.length / 2);
export default {
  name: 'AppraiserCommunity',

  data () {
    return {
      current: 0,
      touchMove: 0,
      moveNumber: 0,
      sellerIndex: 0,
      ttouchStart: 0,
      paginationWidth: 0,
      notesList: notesList,
      goodsList: [],
      preparation: '',
      pullLoading: false,
      popupVisible: false,
      wechatNumber: 'ponhu001',
      bannerList: [
        {
          title: '助力百万唇腭裂儿童重绽笑颜！',
          name: '胖虎与李亚鹏、姚晨等众星出席嫣然天使慈善晚宴！助力百万唇腭裂儿童重绽笑颜！',
          image: 'https://res.ponhu.cn/publicServiceNotes/publicServiceBannerImage1.png',
          synopsis: '2020年1月7日，主题为"爱心传递，点亮幸福温暖"...',
          url: 'https://mp.weixin.qq.com/s/fkZl2_ZCaoJXVu3CGhrSYQ'
        },
        {
          title: '抗击疫情进行时！',
          name: '抗击疫情进行时！这次我们直接要把物资送到第一前线！',
          image: 'https://res.ponhu.cn/publicServiceNotes/publicServiceBannerImage2.png',
          synopsis: '武汉新型肺炎疫情爆发，牵动着每一位国人的心弦...',
          url: 'https://kuaibao.qq.com/s/20200208A0P1F700?refer=spider'
        }
      ],
      swiperOption: {
        on: {
          slideChangeTransitionStart () {
            let width = document.querySelector('.date').clientWidth;
            if (this.realIndex < vm.sellerIndex) {
              vm.moveNumber += vm.paginationWidth
            } else {
              vm.moveNumber -= vm.paginationWidth;
            }
            vm.sellerIndex = this.realIndex;
          }
        }
      }
    }
  },

  created () {
    vm = this;
    this.initialization();
    this.$nextTick(() => {
      this.paginationWidth = Math.ceil(document.querySelector('.paginationContainer').clientWidth / 5);
    })
  },

  methods: {
    // 初始化
    initialization () {
      getPublicWelfarePager().then(res => {
        this.pullLoading = false;
        this.preparation = res.cashPreparation.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
        this.goodsList = res.goods;
      }).catch(() => {
        this.pullLoading = false;
      })
    },
    //商品详情
    goDetail (id) {
      var pl = BrowserInfo();
      if (pl.isWeixin || pl.isQQ) {
        window.location.href = process.env.VUE_APP_ROOT_URL + 'index.html#/goods/' + id;
      } else if (pl.isIOS) { // Ios
        this.$IOS.IosGoodsDetail(id);
      } else { // Android
        this.$Android.AndroidGoodsDetail(id);
      }
    },
    //切换轮播图
    changeBanner (index) {
      this.current = index;
    },
    startBanner (e) {
      this.touchStart = e.touches[0].clientX;
    },
    moveBanner (e) {
      this.touchMove = e.touches[0].clientX;
    },
    endBanner (e) {
      if (this.touchStart > this.touchMove && this.current < this.bannerList.length - 1) {
        this.current ++;
        this.$refs.swiper.swipeTo(this.current);
      } else if (this.touchStart < this.touchMove && this.current > 0) {
        this.current --;
        this.$refs.swiper.swipeTo(this.current);
      }
    },
    //跳转文章
    goNative (name, url) {
      var pl = BrowserInfo();
      if (pl.isWeixin || pl.isQQ) {
        window.location.href = url;
      } else if (pl.isIOS) { // Ios
        this.$IOS.IosJumptoH5(name, url, false);
      } else { // Android
        this.$Android.AndroidJumptoH5(name, url, false);
      }
    },
    //复制微信
    copy () {
      let _this = this
      let clipboard = new ClipboardJS('.wechatNumber');
      clipboard.on('success', function (e) {
        _this.$toast('已经复制到粘贴板！');
        clipboard.destroy();
        e.clearSelection();
      })
      clipboard.on('error', function () {
        _this.$toast('该设备不支持自动复制');
      })
    },
    // 下拉刷新
    onRefresh () {
      setTimeout(() => {
        this.initialization();
      }, 500)
    }
  }
}
</script>

<style>
.van-pull-refresh {
  height: 100% !important;
}

.van-overlay {
  top: 0 !important;
  z-index: 100 !important;
}
</style>

<style lang="less" scoped>

@font-face {  
  font-family: 'DINAB';
  src: url('../../assets/font/DINAlternateBold.ttf');
}

.publicService {
  min-height: 100vh;
  background: #F5F5F5;
  padding: 336px 0 27px;
  box-sizing: border-box;
  background: url('https://res.ponhu.cn/publicServiceNotes/publicServiceBackground.png') no-repeat;
  background-size: 100% 440px;

  img {
    width: 100%;
    height: 100%;
    pointer-events: none;
  }

  .publicServiceTitle {
    color: #222;
    font-size: 32px;
    font-weight: 500;
    padding-left: 25px;
    position: relative;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &::after {
      position: absolute;
      top: 5px;
      left: 0;
      content: '';
      width: 8px;
      height: 40px;
      border-radius: 4px;
      background: linear-gradient(0deg, #FF391F, #FFDC82);
    }

    >img {
      width: 186px;
      height: 48px;
      pointer-events: auto;
    }
  }

  .publicServiceMoney {
    width: calc(100% - 48px);
    margin: 0 auto;
    padding: 34px 36px;
    border-radius: 16px;
    background: #FFFFFF;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 0 10px 0 rgba(33, 24, 21, 0.1);

    .money {
      color: #222;
      font-size: 24px;
      display: flex;
      align-items: center;

      .number {
        color: #FF7342;
        font-weight: bold;
        font-family: 'DINAB';
      }
    }
  }

  .publicServiceNotes {
    width: 100%;
    margin-top: 44px;

    .publicServiceTitle {
      margin-left: 24px;
    }

    .notesContainer {
      width: 100%;

      .swiperPagination {
        width: calc(100% - 48px);
        height: 66px;
        margin: -5px auto 0;
        overflow: hidden;
        position: relative;

        &::after {
          position: absolute;
          top: 8px;
          left: 0;
          content: '';
          width: 100%;
          height: 1px;
          background: linear-gradient(to right,#F5F2F1,#F7CEC0,#F5F2F1);
        }

        .paginationContainer {
          position: absolute;
          z-index: 1;
          width: 100%;
          transition: all linear 0.3s;

          .paginationDots {
            display: flex;
            align-items: center;

            span {
              width: 8px;
              height: 8px;
              margin: 0 auto;
              display: block;
              border-radius: 50%;
              background: #FF7342;
            }

            .dotsActive {
              width: 18px;
              height: 18px;
              background: #FFF;
              border-radius: 50%;
              box-sizing: border-box;
              border: 3px solid #FF7342;
              animation: display 0.5s forwards;
            }
          }

          .paginationDate {
            height: 35px;
            font-size: 24px;
            margin-top: 8px;
            color: #C6C6C6;
            font-weight: bold;
            font-family: 'DINAB';
            display: flex;
            align-items: center;

            .date {
              text-align: center;
            }

            .dateActive {
              font-size: 36px;
              color: #FF7342;
            }
          }
        }
      }
    }
  }

  .publicServiceProcedure {
    width: calc(100% - 48px);
    margin: 49px auto 0;

    >img {
      margin-top: 23px;
    }
  }

  .publicServiceGoods {
    width: calc(100% - 48px);
    margin: 43px auto 0;

    .goodsTip {
      color: #999;
      font-size: 20px;
      margin-top: 10px;
      padding-left: 25px;
      margin-bottom: 14px;
      box-sizing: border-box;
    }

    ul {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      li {
        width: 343px;
        overflow: hidden;
        margin-top: 16px;
        background: #FFF;
        border-radius: 8px;
        position: relative;

        >img {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          width: 127px;
          height: 40px;
        }

        .goodsImage {
          width: 100%;
          height: 343px;
          position: relative;

          .label {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 2;
          }
        }

        .goodsNews {
          width: 100%;
          box-sizing: border-box;
          padding: 24px 11px 12px;

          .brand {
            width: 100%;
            color: #222;
            font-size: 28px;
            font-weight: 500;
            display: flex;
            align-items: center;
            justify-content: space-between;

            span {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }

            .status {
              flex-shrink: 0;
              font-size: 20px;
            }
          }

          .describe {
            width: 100%;
            color: #222;
            font-size: 20px;
            margin-top: 10px;
            line-height: 28px;
          }

          .price {
            font-size: 32px;
            font-weight: 500;
            color: #DA3232;
            margin-top: 8px;

            span {
              color: #999;
              font-size: 20px;
              font-weight: 300;
              margin-left: 8px;
              text-decoration: line-through;
            }
          }

          .people {
            width: 100%;
            margin-top: 11px;
            padding-top: 12px;
            border-top: 1px solid #F7F7F7;
            display: flex;
            align-items: center;

            >img {
              width: 36px;
              height: 36px;
              border-radius: 50%;
            }

            span {
              font-size: 18px;
              color: #282828;
              margin-left: 7px;
            }
          }
        }
      }
    }
  }

  .publicServiceBanner {
    width: calc(100% - 48px);
    margin: 24px auto 0;
    position: relative;

    .van-swipe {
      width: 100%;
      height: 152px;
      overflow: hidden;
      border-radius: 8px;
    }

    .bannerContaner {
      position: absolute;
      bottom: 0;
      width: 100%;
      color: #FFF;
      border-radius: 8px;
      box-sizing: border-box;
      padding: 38px 24px 24px;
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 100%);
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      .bannerNews {
        width: 530px;
        box-sizing: border-box;

        .title {
          width: 100%;
          font-size: 28px;
          font-weight: 500;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        
        .synopsis {
          width: 100%;
          font-size: 24px;
          margin-top: 6px;
          font-weight: 300;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .indicator {
        font-size: 36px;

        span {
          font-size: 20px;
        }
      }
    }
  }

  .publicServiceAbout {
    width: calc(100% - 48px);
    margin: 42px auto 0;

    .aboutContainer {
      width: 100%;
      color: #999;
      font-size: 24px;
      margin-top: 28px;
      line-height: 32px;
      background: #FFF;
      padding: 44px 24px;
      box-sizing: border-box;
      border-radius: 8px 16px 16px 16px;
    }
  }

  .van-popup {
    height: auto;

    .title {
      width: 100%;
      font-size: 17px;
      color: #282828;
      font-weight: 500;
      line-height: 50px;
      background: #FFF;
      text-align: center;
      border-bottom: 1px solid #EEE;

      >img {
        position: absolute;
        top: 18px;
        left: 18px;
        width: 16px;
        height: 16px;
        pointer-events: auto;
      }
    }

    .popupNews {
      width: 100%;
      font-size: 13px;
      color: #282828;
      line-height: 1.2;
      padding: 8px 18px;
      box-sizing: border-box;

      p {
        display: flex;
        align-items: center;

        .wechatNumber {
          width: 68px;
          height: 23px;
          font-size: 11px;
          line-height: 25px;
          text-align: center;
          background: #F7F7F7;
          border-radius: 24px;
          display: inline-block;
        }
      }
    }

    .complete {
      width: 100%;
      font-size: 17px;
      font-weight: 500;
      color: #282828;
      line-height: 45px;
      text-align: center;
      background: #FFD133;
    }
  }
  
  @keyframes display {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
}
</style>
